(function (globalScope, factory) {
  'use strict';

  var productMatches = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = productMatches;
  }

  if (globalScope && globalScope.document) {
    globalScope.HauberVibrationProductMatches = productMatches;
    productMatches.boot(globalScope.document);
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var ROOT_SELECTOR = '[data-vibration-calculator]';
  var PRODUCT_SELECTOR = '[data-vibration-product-matches]';
  var UPDATE_DEBOUNCE_MS = 1000;
  var FILTER_PARAMS = Object.freeze({
    measurement: 'filter.p.m.custom.messgrose',
    range: 'filter.p.m.custom.messbereich',
    frequency: 'filter.p.m.custom.filter_frequenzbereich',
    series: 'filter.p.m.custom.serie',
  });
  var TARGET_DEFINITIONS = Object.freeze({
    acceleration_rms_g: Object.freeze({
      metric: 'a-rms',
      measurement: 'g, a-rms',
      resultKey: 'acceleration_rms_g',
    }),
    acceleration_rms_si: Object.freeze({
      metric: 'a-rms',
      measurement: 'g, a-rms',
      resultKey: 'acceleration_rms_g',
    }),
    acceleration_peak_g: Object.freeze({
      metric: 'a-peak-hold',
      measurement: 'g, a-peak-hold',
      resultKey: 'acceleration_peak_g',
    }),
    acceleration_peak_si: Object.freeze({
      metric: 'a-peak-hold',
      measurement: 'g, a-peak-hold',
      resultKey: 'acceleration_peak_g',
    }),
    velocity_rms: Object.freeze({
      metric: 'v-rms',
      measurement: 'mm/s, v-rms',
      resultKey: 'velocity_rms',
    }),
  });

  function unique(values) {
    var result = [];

    for (var index = 0; index < values.length; index += 1) {
      if (result.indexOf(values[index]) === -1) result.push(values[index]);
    }

    return result;
  }

  function normalizeFilterText(value) {
    var normalized = String(value == null ? '' : value);

    if (typeof normalized.normalize === 'function') normalized = normalized.normalize('NFKC');

    return normalized
      .replace(/\u2026/g, '...')
      .replace(/(\d),(\d)/g, '$1.$2')
      .replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, '-')
      .replace(/\s*\.\.\.\s*/g, '...')
      .replace(/\s*\/\s*/g, '/')
      .replace(/\s*,\s*/g, ', ')
      .replace(/\s*&\s*/g, ' & ')
      .replace(/[\s\u00a0]+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function normalizeSeriesCodes(value) {
    return unique(String(value == null ? '' : value)
      .split(/[|,;]/)
      .map(function (code) {
        return normalizeFilterText(code);
      })
      .filter(Boolean));
  }

  function seriesFamily(value) {
    var normalized = normalizeFilterText(value);
    var compact = normalized.replace(/[^a-z0-9]/g, '');
    var prefix = compact.slice(0, 4);

    if (prefix === 'he05' || prefix === 'he10' || prefix === 'he20') return prefix + 'x';
    return normalized;
  }

  function selectFallbackProducts(matchedEntries, entries, maximumCount) {
    var limit = Number(maximumCount);
    if (!Number.isFinite(limit) || limit <= 0 || !Array.isArray(entries)) return [];

    limit = Math.floor(limit);
    var usedFamilies = [];
    var usedProductIds = [];
    var candidates = [];
    var selected = [];

    function remember(entry) {
      if (!entry) return;
      var productId = String(entry.productId || '');
      var family = normalizeFilterText(entry.family) || (productId ? 'product-' + productId : '');
      if (productId && usedProductIds.indexOf(productId) === -1) usedProductIds.push(productId);
      if (family && usedFamilies.indexOf(family) === -1) usedFamilies.push(family);
    }

    for (var matchedIndex = 0; matchedIndex < (matchedEntries || []).length; matchedIndex += 1) {
      remember(matchedEntries[matchedIndex]);
    }

    for (var index = 0; index < entries.length; index += 1) {
      var entry = entries[index];
      if (!entry) continue;

      var entryProductId = String(entry.productId || '');
      if (!entryProductId || usedProductIds.indexOf(entryProductId) !== -1) continue;
      if (candidates.some(function (candidate) { return candidate.productId === entryProductId; })) continue;

      candidates.push({
        family: normalizeFilterText(entry.family) || 'product-' + entryProductId,
        node: entry.node,
        order: Number.isFinite(Number(entry.order)) ? Number(entry.order) : index,
        productId: entryProductId,
        seriesCodes: normalizeSeriesCodes(entry.seriesCodes),
        source: 'fallback',
      });
    }

    for (var candidateIndex = 0; candidateIndex < candidates.length && selected.length < limit; candidateIndex += 1) {
      var candidate = candidates[candidateIndex];
      if (usedFamilies.indexOf(candidate.family) !== -1) continue;

      selected.push(candidate);
      remember(candidate);
    }

    for (var fillIndex = 0; fillIndex < candidates.length && selected.length < limit; fillIndex += 1) {
      var fillCandidate = candidates[fillIndex];
      if (usedProductIds.indexOf(fillCandidate.productId) !== -1) continue;

      selected.push(fillCandidate);
      remember(fillCandidate);
    }

    return selected;
  }

  function parseRange(value) {
    var match = normalizeFilterText(value).match(/(-?\d+(?:\.\d+)?)\s*\.\.\.\s*(-?\d+(?:\.\d+)?)/);
    if (!match) return null;

    var minimum = Number(match[1]);
    var maximum = Number(match[2]);
    if (!Number.isFinite(minimum) || !Number.isFinite(maximum) || maximum < minimum) return null;

    return Object.freeze({minimum: minimum, maximum: maximum});
  }

  function parseFrequencyIntervals(value) {
    var normalized = normalizeFilterText(value);
    var pattern = /(-?\d+(?:\.\d+)?)\s*\.\.\.\s*(-?\d+(?:\.\d+)?)\s*hz/g;
    var intervals = [];
    var match;

    while ((match = pattern.exec(normalized)) !== null) {
      var minimum = Number(match[1]);
      var maximum = Number(match[2]);
      if (Number.isFinite(minimum) && Number.isFinite(maximum) && maximum >= minimum) {
        intervals.push(Object.freeze({minimum: minimum, maximum: maximum}));
      }
    }

    return intervals;
  }

  function getTargetDefinition(targetKey) {
    return Object.prototype.hasOwnProperty.call(TARGET_DEFINITIONS, targetKey)
      ? TARGET_DEFINITIONS[targetKey]
      : null;
  }

  function targetUnsupportedReason(targetKey) {
    if (!targetKey) return 'initial';
    if (targetKey === 'velocity_peak') return 'velocity_peak';
    if (targetKey.indexOf('displacement_') === 0) return 'displacement';
    return getTargetDefinition(targetKey) ? null : 'unsupported';
  }

  function optionsFor(catalog, parameterName) {
    if (!Array.isArray(catalog)) return [];

    return catalog.filter(function (option) {
      return option && option.param === parameterName && typeof option.value === 'string';
    });
  }

  function findMeasurementValues(catalog, definition) {
    if (!definition) return [];
    var expected = normalizeFilterText(definition.measurement);

    return unique(optionsFor(catalog, FILTER_PARAMS.measurement)
      .filter(function (option) {
        return normalizeFilterText(option.value) === expected;
      })
      .map(function (option) {
        return option.value;
      }));
  }

  function selectMeasurementRange(catalog, definition, measuredValue) {
    if (!definition || !Number.isFinite(measuredValue) || measuredValue < 0) return null;

    var expectedSuffix = normalizeFilterText(definition.measurement);
    var candidates = optionsFor(catalog, FILTER_PARAMS.range)
      .map(function (option) {
        var normalized = normalizeFilterText(option.value);
        var range = parseRange(option.value);

        if (!range || normalized.indexOf(expectedSuffix) === -1) return null;
        if (range.minimum > measuredValue || range.maximum < measuredValue) return null;

        return {
          option: option,
          normalized: normalized,
          minimum: range.minimum,
          maximum: range.maximum,
        };
      })
      .filter(Boolean)
      .sort(function (left, right) {
        if (left.maximum !== right.maximum) return left.maximum - right.maximum;
        if (left.minimum !== right.minimum) return right.minimum - left.minimum;
        return left.normalized.localeCompare(right.normalized);
      });

    if (candidates.length === 0) return null;

    var selected = candidates[0];
    var selectedValues = unique(candidates
      .filter(function (candidate) {
        return candidate.normalized === selected.normalized;
      })
      .map(function (candidate) {
        return candidate.option.value;
      }));
    var nextCandidate = null;

    for (var index = 0; index < candidates.length; index += 1) {
      if (candidates[index].maximum > selected.maximum) {
        nextCandidate = candidates[index];
        break;
      }
    }

    var nextValues = nextCandidate ? unique(candidates
      .filter(function (candidate) {
        return candidate.normalized === nextCandidate.normalized;
      })
      .map(function (candidate) {
        return candidate.option.value;
      })) : [];

    return Object.freeze({
      label: selected.option.value,
      minimum: selected.minimum,
      maximum: selected.maximum,
      values: Object.freeze(selectedValues),
      nextLabel: nextCandidate ? nextCandidate.option.value : null,
      nextMaximum: nextCandidate ? nextCandidate.maximum : null,
      nextValues: Object.freeze(nextValues),
    });
  }

  function shouldIncludeNextRange(rangeSelection, measuredValue) {
    if (!rangeSelection || !Number.isFinite(measuredValue) || measuredValue < 0) return false;
    if (!Number.isFinite(rangeSelection.maximum) || rangeSelection.maximum <= 0) return false;
    if (!Array.isArray(rangeSelection.nextValues) || rangeSelection.nextValues.length === 0) return false;
    return measuredValue / rangeSelection.maximum * 100 > 70;
  }

  function frequencyOptionIsCompatible(value, metric) {
    var normalized = normalizeFilterText(value);

    if (normalized.indexOf('a-raw') !== -1) return false;
    if (normalized.indexOf('crestwert') !== -1) return metric === 'a-peak-hold';

    var hasMetricQualifier = normalized.indexOf('v-rms') !== -1
      || normalized.indexOf('a-rms') !== -1
      || normalized.indexOf('a-peak-hold') !== -1;

    if (!hasMetricQualifier) return true;
    return normalized.indexOf(metric) !== -1;
  }

  function selectFrequencyValues(catalog, metric, frequencyHz) {
    if (!Number.isFinite(frequencyHz) || frequencyHz <= 0) return [];

    return unique(optionsFor(catalog, FILTER_PARAMS.frequency)
      .filter(function (option) {
        if (!frequencyOptionIsCompatible(option.value, metric)) return false;
        if (!Number.isFinite(Number(option.count)) || Number(option.count) <= 0) return false;

        return parseFrequencyIntervals(option.value).some(function (interval) {
          return interval.minimum <= frequencyHz && interval.maximum >= frequencyHz;
        });
      })
      .map(function (option) {
        return option.value;
      }));
  }

  function selectDiversitySeriesValues(catalog, existingFamilies, maximumFamilies) {
    var limit = Math.floor(Number(maximumFamilies));
    if (!Number.isFinite(limit) || limit <= 0) return [];

    var usedFamilies = unique((existingFamilies || []).map(seriesFamily).filter(Boolean));
    var candidates = optionsFor(catalog, FILTER_PARAMS.series)
      .filter(function (option) {
        return Number.isFinite(Number(option.count)) && Number(option.count) > 0;
      })
      .map(function (option, index) {
        return {
          value: option.value,
          family: seriesFamily(option.value),
          count: Number(option.count),
          order: index,
        };
      })
      .filter(function (candidate) {
        return candidate.family && usedFamilies.indexOf(candidate.family) === -1;
      });
    var preferredFamilies = ['he05x', 'he10x', 'he20x'];
    var candidateFamilies = unique(candidates.map(function (candidate) {
      return candidate.family;
    })).sort(function (left, right) {
      var leftPreferred = preferredFamilies.indexOf(left);
      var rightPreferred = preferredFamilies.indexOf(right);
      if (leftPreferred !== -1 || rightPreferred !== -1) {
        if (leftPreferred === -1) return 1;
        if (rightPreferred === -1) return -1;
        return leftPreferred - rightPreferred;
      }

      var leftCount = candidates.filter(function (candidate) { return candidate.family === left; })
        .reduce(function (sum, candidate) { return sum + candidate.count; }, 0);
      var rightCount = candidates.filter(function (candidate) { return candidate.family === right; })
        .reduce(function (sum, candidate) { return sum + candidate.count; }, 0);
      if (leftCount !== rightCount) return rightCount - leftCount;
      return left.localeCompare(right);
    }).slice(0, limit);

    return unique(candidates.filter(function (candidate) {
      return candidateFamilies.indexOf(candidate.family) !== -1;
    }).sort(function (left, right) {
      return left.order - right.order;
    }).map(function (candidate) {
      return candidate.value;
    }));
  }

  function createFilterUrl(baseUrl, selections, sectionId, baseHref) {
    var url = new URL(baseUrl, baseHref || 'https://hauber.invalid/');
    var parameterNames = Object.keys(FILTER_PARAMS).map(function (key) {
      return FILTER_PARAMS[key];
    });

    url.searchParams.delete('section_id');
    url.searchParams.delete('page');
    for (var index = 0; index < parameterNames.length; index += 1) {
      url.searchParams.delete(parameterNames[index]);
    }

    var frequencyValues = Array.isArray(selections.frequency)
      ? selections.frequency
      : (selections.frequency ? [selections.frequency] : []);
    var groups = [
      {param: FILTER_PARAMS.measurement, values: selections.measurement || []},
      {param: FILTER_PARAMS.range, values: selections.range || []},
      {param: FILTER_PARAMS.frequency, values: frequencyValues},
      {param: FILTER_PARAMS.series, values: selections.series || []},
    ];

    for (var groupIndex = 0; groupIndex < groups.length; groupIndex += 1) {
      for (var valueIndex = 0; valueIndex < groups[groupIndex].values.length; valueIndex += 1) {
        url.searchParams.append(groups[groupIndex].param, groups[groupIndex].values[valueIndex]);
      }
    }

    if (sectionId) url.searchParams.set('section_id', sectionId);
    return url;
  }

  function relativeUrl(url) {
    return url.pathname + url.search + url.hash;
  }

  function replaceTemplate(template, replacements) {
    var result = String(template || '');
    var keys = Object.keys(replacements || {});

    for (var index = 0; index < keys.length; index += 1) {
      result = result.split('{{ ' + keys[index] + ' }}').join(String(replacements[keys[index]]));
    }

    return result;
  }

  function parseCatalog(responseRoot) {
    if (!responseRoot || !responseRoot.querySelectorAll) return [];
    var nodes = responseRoot.querySelectorAll('[data-vibration-filter-option]');
    var catalog = [];

    for (var index = 0; index < nodes.length; index += 1) {
      catalog.push(Object.freeze({
        param: nodes[index].getAttribute('data-filter-param') || '',
        value: nodes[index].getAttribute('data-filter-value') || '',
        count: Number(nodes[index].getAttribute('data-filter-count') || 0),
      }));
    }

    return catalog;
  }

  function readConfig(moduleRoot) {
    var configElement = moduleRoot.querySelector('[data-vibration-product-config]');
    if (!configElement) throw new Error('configuration');

    var config = JSON.parse(configElement.textContent);
    if (!config || typeof config.collection_url !== 'string' || !config.collection_url) {
      throw new Error('configuration');
    }

    return config;
  }

  function parseResponse(text, documentReference) {
    var view = documentReference && documentReference.defaultView;
    var Parser = view && view.DOMParser ? view.DOMParser : (typeof DOMParser === 'function' ? DOMParser : null);
    if (!Parser) throw new Error('markup');

    var parsed = new Parser().parseFromString(text, 'text/html');
    var responseRoot = parsed.querySelector('[data-vibration-products-response]');
    if (!responseRoot) throw new Error('markup');
    return responseRoot;
  }

  function setStatus(moduleRoot, text) {
    var status = moduleRoot.querySelector('[data-vibration-products-status]');
    if (status) status.textContent = text;
  }

  function setButton(moduleRoot, href, label) {
    var button = moduleRoot.querySelector('[data-vibration-products-link]');
    if (!button) return;
    button.href = href;
    button.textContent = label;
  }

  function clearCards(moduleRoot) {
    var list = moduleRoot.querySelector('[data-vibration-products-list]');
    var container = moduleRoot.querySelector('[data-vibration-products-container]');
    if (list) list.innerHTML = '';
    if (container) container.hidden = true;
    moduleRoot.removeAttribute('data-vibration-products-matched');
  }

  function setBusy(moduleRoot, busy) {
    var loader = moduleRoot.querySelector('[data-vibration-products-loading]');
    var products = moduleRoot.querySelector('[data-vibration-products-container]');
    var productLink = moduleRoot.querySelector('[data-vibration-products-link]');

    if (busy) moduleRoot.setAttribute('aria-busy', 'true');
    else moduleRoot.removeAttribute('aria-busy');
    if (loader) loader.hidden = !busy;
    if (products && typeof products.setAttribute === 'function' && typeof products.removeAttribute === 'function') {
      if (busy) products.setAttribute('inert', '');
      else products.removeAttribute('inert');
    }
    if (productLink && typeof productLink.setAttribute === 'function' && typeof productLink.removeAttribute === 'function') {
      if (busy) {
        productLink.setAttribute('inert', '');
        productLink.setAttribute('aria-disabled', 'true');
      } else {
        productLink.removeAttribute('inert');
        productLink.removeAttribute('aria-disabled');
      }
    }
  }

  function responseTotal(responseRoot) {
    var value = Number(responseRoot.getAttribute('data-total'));
    return Number.isFinite(value) && value >= 0 ? value : 0;
  }

  function responseSelection(responseRoot, responseList) {
    var metadata = responseRoot.querySelector('[data-vibration-selection-meta]');
    var renderedCount = metadata
      ? Number(metadata.getAttribute('data-vibration-rendered-count'))
      : NaN;

    if (!Number.isFinite(renderedCount) || renderedCount < 0) {
      renderedCount = responseList && responseList.children ? responseList.children.length : 0;
    }

    return Object.freeze({
      renderedCount: Math.floor(renderedCount),
      seriesCodes: metadata
        ? normalizeSeriesCodes(metadata.getAttribute('data-vibration-selected-series'))
        : [],
    });
  }

  function responseProductIds(responseRoot) {
    if (!responseRoot || !responseRoot.querySelectorAll) return [];
    var nodes = responseRoot.querySelectorAll('[data-vibration-result-product-id]');
    var productIds = [];

    for (var index = 0; index < nodes.length; index += 1) {
      var productId = nodes[index].getAttribute('data-vibration-result-product-id');
      if (productId) productIds.push(String(productId));
    }

    return unique(productIds);
  }

  function combinedResponseTotal(primaryResponseRoot, nextResponseRoot) {
    var primaryTotal = responseTotal(primaryResponseRoot);
    var nextTotal = responseTotal(nextResponseRoot);
    var primaryIds = responseProductIds(primaryResponseRoot);
    var nextIds = responseProductIds(nextResponseRoot);
    var hasCompletePrimaryCatalog = primaryIds.length >= primaryTotal;
    var hasCompleteNextCatalog = nextIds.length >= nextTotal;

    if (hasCompletePrimaryCatalog && hasCompleteNextCatalog) {
      return unique(primaryIds.concat(nextIds)).length;
    }
    return primaryTotal + nextTotal;
  }

  function responseCardEntries(responseRoot, source) {
    var responseList = responseRoot && responseRoot.querySelector
      ? responseRoot.querySelector('[data-vibration-products-list]')
      : null;
    var nodes = responseList && responseList.children ? responseList.children : [];
    var entries = [];

    for (var index = 0; index < nodes.length; index += 1) {
      if (!nodes[index] || typeof nodes[index].getAttribute !== 'function') continue;
      entries.push({
        family: normalizeFilterText(nodes[index].getAttribute('data-vibration-product-family')),
        node: nodes[index],
        order: index,
        productId: String(nodes[index].getAttribute('data-vibration-product-id') || source + '-' + index),
        seriesCodes: normalizeSeriesCodes(nodes[index].getAttribute('data-vibration-product-series')),
        source: source,
      });
    }

    return entries;
  }

  function selectProductEntries(combinedEntries, nextEntries, nextProductIds, maximumCount) {
    var limit = Number(maximumCount);
    if (!Number.isFinite(limit) || limit <= 0) return [];
    limit = Math.floor(limit);

    var nextIds = unique((nextProductIds || []).map(function (productId) {
      return String(productId);
    }));
    var candidates = [];
    var candidateById = {};

    function addCandidate(entry, isNext) {
      if (!entry) return;
      var productId = String(entry.productId || '');
      if (!productId) return;

      if (Object.prototype.hasOwnProperty.call(candidateById, productId)) {
        candidateById[productId].isNext = candidateById[productId].isNext || isNext;
        return;
      }

      var candidate = {
        family: normalizeFilterText(entry.family) || 'product-' + productId,
        isNext: Boolean(isNext),
        node: entry.node,
        order: Number.isFinite(Number(entry.order)) ? Number(entry.order) : candidates.length,
        productId: productId,
        seriesCodes: normalizeSeriesCodes(entry.seriesCodes),
        source: entry.source === 'next' ? 'next' : 'combined',
      };
      candidateById[productId] = candidate;
      candidates.push(candidate);
    }

    for (var combinedIndex = 0; combinedIndex < (combinedEntries || []).length; combinedIndex += 1) {
      var combinedEntry = combinedEntries[combinedIndex];
      addCandidate(combinedEntry, nextIds.indexOf(String(combinedEntry.productId)) !== -1);
    }
    for (var nextIndex = 0; nextIndex < (nextEntries || []).length; nextIndex += 1) {
      addCandidate(nextEntries[nextIndex], true);
    }

    var targetCount = Math.min(limit, candidates.length);
    if (targetCount === 0) return [];
    var requiresNext = candidates.some(function (candidate) {
      return candidate.isNext;
    });
    var best = null;
    var bestScore = null;

    function scoreSelection(selection) {
      var families = unique(selection.map(function (candidate) {
        return candidate.family;
      })).length;
      var combinedCount = selection.filter(function (candidate) {
        return candidate.source === 'combined';
      }).length;
      var nextCount = selection.filter(function (candidate) {
        return candidate.isNext;
      }).length;
      var orderScore = selection.reduce(function (sum, candidate) {
        return sum + candidate.order + (candidate.source === 'next' ? 100 : 0);
      }, 0);
      return [families, combinedCount, -nextCount, -orderScore];
    }

    function scoreIsBetter(left, right) {
      if (!right) return true;
      for (var scoreIndex = 0; scoreIndex < left.length; scoreIndex += 1) {
        if (left[scoreIndex] !== right[scoreIndex]) return left[scoreIndex] > right[scoreIndex];
      }
      return false;
    }

    function visit(startIndex, selection) {
      if (selection.length === targetCount) {
        if (requiresNext && !selection.some(function (candidate) { return candidate.isNext; })) return;
        var score = scoreSelection(selection);
        if (scoreIsBetter(score, bestScore)) {
          best = selection.slice();
          bestScore = score;
        }
        return;
      }

      for (var index = startIndex; index <= candidates.length - (targetCount - selection.length); index += 1) {
        selection.push(candidates[index]);
        visit(index + 1, selection);
        selection.pop();
      }
    }

    visit(0, []);
    return (best || candidates.slice(0, targetCount)).sort(function (left, right) {
      if (left.source !== right.source) return left.source === 'combined' ? -1 : 1;
      return left.order - right.order;
    });
  }

  function fallbackProductEntries(moduleRoot) {
    var template = moduleRoot.querySelector('[data-vibration-product-fallback-template]');
    var templateContent = template && template.content;
    if (!templateContent || !templateContent.querySelectorAll) return [];

    var nodes = templateContent.querySelectorAll('[data-vibration-product-id]');
    var entries = [];

    for (var index = 0; index < nodes.length; index += 1) {
      entries.push({
        family: normalizeFilterText(nodes[index].getAttribute('data-vibration-product-family')),
        node: nodes[index],
        order: index,
        productId: String(nodes[index].getAttribute('data-vibration-product-id') || ''),
        seriesCodes: normalizeSeriesCodes(nodes[index].getAttribute('data-vibration-product-series')),
        source: 'fallback',
      });
    }

    return entries;
  }

  function appendFallbackProducts(moduleRoot, targetList, matchedEntries, maximumCount) {
    if (!targetList || typeof targetList.appendChild !== 'function') return 0;

    var selectedEntries = selectFallbackProducts(
      matchedEntries,
      fallbackProductEntries(moduleRoot),
      maximumCount,
    );

    for (var index = 0; index < selectedEntries.length; index += 1) {
      targetList.appendChild(selectedEntries[index].node.cloneNode(true));
    }

    return selectedEntries.length;
  }

  function runCardEnhancements(moduleRoot) {
    var documentReference = moduleRoot.ownerDocument;
    var view = documentReference && documentReference.defaultView;
    if (!view) return;

    var animated = moduleRoot.querySelectorAll('[data-sal]');
    for (var index = 0; index < animated.length; index += 1) {
      animated[index].classList.add('sal-animate');
    }

    var functionNames = [
      'productcardVariantsAsync',
      'semanticInputAsync',
      'semanticSelectAsync',
      'schemeTooltipAsync',
      'listScrollableAsync',
    ];

    for (var functionIndex = 0; functionIndex < functionNames.length; functionIndex += 1) {
      if (typeof view[functionNames[functionIndex]] === 'function') {
        try {
          view[functionNames[functionIndex]]();
        } catch (error) {
          // The server-rendered cards remain usable without optional theme enhancements.
        }
      }
    }

    if (view.ajaxCart && typeof view.ajaxCart.init === 'function') {
      try {
        view.ajaxCart.init();
      } catch (error) {
        // Keep native product forms available if the optional AJAX layer is unavailable.
      }
    }

    if (view.quickShop && typeof view.quickShop.init === 'function') {
      try {
        view.quickShop.init();
      } catch (error) {
        // Product links and native forms remain the fallback.
      }
    }
  }

  function renderCards(moduleRoot, responseRoot, nextResponseRoot, diversityResponseRoot) {
    var responseList = responseRoot.querySelector('[data-vibration-products-list]');
    var targetList = moduleRoot.querySelector('[data-vibration-products-list]');
    var container = moduleRoot.querySelector('[data-vibration-products-container]');
    if (!responseList || !targetList || !container) throw new Error('markup');

    var selection = responseSelection(responseRoot, responseList);
    var renderedCount = selection.renderedCount;
    var selectedEntries = responseCardEntries(responseRoot, 'combined');
    var diversityEntries = diversityResponseRoot
      ? responseCardEntries(diversityResponseRoot, 'combined')
      : [];

    if (nextResponseRoot || diversityEntries.length > 0) {
      selectedEntries = selectProductEntries(
        responseCardEntries(responseRoot, 'combined').concat(diversityEntries),
        responseCardEntries(nextResponseRoot, 'next'),
        responseProductIds(nextResponseRoot),
        3,
      );
      targetList.innerHTML = '';
      for (var index = 0; index < selectedEntries.length; index += 1) {
        targetList.appendChild(selectedEntries[index].node.cloneNode(true));
      }
      renderedCount = selectedEntries.length;
    } else {
      targetList.innerHTML = responseList.innerHTML;
      if (selectedEntries.length > renderedCount) selectedEntries = selectedEntries.slice(0, renderedCount);
    }

    var fallbackCount = appendFallbackProducts(
      moduleRoot,
      targetList,
      selectedEntries,
      Math.max(0, 3 - renderedCount),
    );
    var displayedCount = renderedCount + fallbackCount;

    container.hidden = displayedCount === 0;
    if (renderedCount > 0) moduleRoot.setAttribute('data-vibration-products-matched', 'true');
    else moduleRoot.removeAttribute('data-vibration-products-matched');
    if (displayedCount > 0) runCardEnhancements(moduleRoot);

    return Object.freeze({
      displayedCount: displayedCount,
      fallbackCount: fallbackCount,
      productCount: renderedCount,
    });
  }

  function renderFallbackProducts(moduleRoot) {
    var targetList = moduleRoot.querySelector('[data-vibration-products-list]');
    var container = moduleRoot.querySelector('[data-vibration-products-container]');
    if (!targetList || !container) return 0;

    targetList.innerHTML = '';
    var fallbackCount = appendFallbackProducts(moduleRoot, targetList, [], 3);
    container.hidden = fallbackCount === 0;
    moduleRoot.removeAttribute('data-vibration-products-matched');
    if (fallbackCount > 0) runCardEnhancements(moduleRoot);
    return fallbackCount;
  }

  function fallbackStatus(primaryText, fallbackText, fallbackCount) {
    if (fallbackCount <= 0) return primaryText;
    if (String(primaryText || '').trim() === String(fallbackText || '').trim()) return primaryText;
    return [primaryText, fallbackText].filter(Boolean).join(' ');
  }

  function showFallbackProducts(moduleRoot, config, primaryStatus) {
    clearCards(moduleRoot);
    var fallbackCount = renderFallbackProducts(moduleRoot);
    setBusy(moduleRoot, false);
    setStatus(moduleRoot, fallbackStatus(primaryStatus, config.labels.fallback_zero, fallbackCount));
    setButton(moduleRoot, config.collection_url, config.labels.generic_button);
    return fallbackCount;
  }

  function requestResponse(moduleRoot, url, signal) {
    var view = moduleRoot.ownerDocument && moduleRoot.ownerDocument.defaultView;
    if (!view || typeof view.fetch !== 'function') return Promise.reject(new Error('network'));

    return view.fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      signal: signal,
    }).then(function (response) {
      if (!response.ok) throw new Error('network');
      return response.text();
    }).then(function (text) {
      return parseResponse(text, moduleRoot.ownerDocument);
    });
  }

  function requestOptionalResponse(moduleRoot, url, signal) {
    return requestResponse(moduleRoot, url, signal).catch(function (error) {
      if (error && error.name === 'AbortError') throw error;
      return null;
    });
  }

  function requestFilterCatalog(moduleRoot, url, signal, state) {
    if (!state.frequencyCatalogs) state.frequencyCatalogs = Object.create(null);
    if (Object.prototype.hasOwnProperty.call(state.frequencyCatalogs, url)) {
      return Promise.resolve(state.frequencyCatalogs[url]);
    }

    return requestResponse(moduleRoot, url, signal).then(function (responseRoot) {
      var catalog = parseCatalog(responseRoot);
      state.frequencyCatalogs[url] = catalog;
      return catalog;
    });
  }

  function requestOptionalFilterCatalog(moduleRoot, url, signal, state) {
    return requestFilterCatalog(moduleRoot, url, signal, state).catch(function (error) {
      if (error && error.name === 'AbortError') throw error;
      return null;
    });
  }

  function currentResultValue(state, definition) {
    if (!state.result || !definition) return null;
    var value = Number(state.result[definition.resultKey]);
    return Number.isFinite(value) && value >= 0 ? value : null;
  }

  function currentFrequency(state) {
    if (!state.result) return null;
    var value = Number(state.result.frequency_hz);
    return Number.isFinite(value) && value > 0 ? value : null;
  }

  function ensureCurrent(state, sequence) {
    if (sequence !== state.requestSequence) {
      var error = new Error('stale');
      error.name = 'AbortError';
      throw error;
    }
  }

  function clearScheduledUpdate(moduleRoot, state) {
    if (!state || state.updateTimer == null) return false;

    var view = moduleRoot.ownerDocument && moduleRoot.ownerDocument.defaultView;
    var clearTimer = view && typeof view.clearTimeout === 'function'
      ? view.clearTimeout
      : (typeof clearTimeout === 'function' ? clearTimeout : null);
    if (clearTimer) clearTimer.call(view, state.updateTimer);
    state.updateTimer = null;
    return true;
  }

  function scheduleMatchesUpdate(calculatorRoot, moduleRoot, config, state) {
    clearScheduledUpdate(moduleRoot, state);

    state.requestSequence += 1;
    if (state.controller) state.controller.abort();
    state.controller = null;

    var view = moduleRoot.ownerDocument && moduleRoot.ownerDocument.defaultView;
    var setTimer = view && typeof view.setTimeout === 'function'
      ? view.setTimeout
      : (typeof setTimeout === 'function' ? setTimeout : null);
    if (!setTimer) return updateMatches(calculatorRoot, moduleRoot, config, state);

    setBusy(moduleRoot, true);
    setStatus(moduleRoot, config.labels.loading);

    state.updateTimer = setTimer.call(view, function () {
      state.updateTimer = null;
      updateMatches(calculatorRoot, moduleRoot, config, state);
    }, UPDATE_DEBOUNCE_MS);
    return true;
  }

  function updateMatches(calculatorRoot, moduleRoot, config, state) {
    clearScheduledUpdate(moduleRoot, state);
    state.requestSequence += 1;
    var sequence = state.requestSequence;

    if (state.controller) state.controller.abort();
    state.controller = null;

    var unsupportedReason = targetUnsupportedReason(state.targetKey);
    if (unsupportedReason === 'initial') {
      showFallbackProducts(moduleRoot, config, config.labels.initial);
      return Promise.resolve(false);
    }
    if (unsupportedReason) {
      showFallbackProducts(
        moduleRoot,
        config,
        config.labels['unsupported_' + unsupportedReason] || config.labels.unsupported,
      );
      return Promise.resolve(false);
    }

    var definition = getTargetDefinition(state.targetKey);
    var measuredValue = currentResultValue(state, definition);
    var frequencyHz = currentFrequency(state);
    if (measuredValue === null || frequencyHz === null) {
      showFallbackProducts(moduleRoot, config, config.labels.waiting);
      return Promise.resolve(false);
    }

    var view = moduleRoot.ownerDocument && moduleRoot.ownerDocument.defaultView;
    var Controller = view && view.AbortController;
    state.controller = Controller ? new Controller() : {abort: function () {}, signal: undefined};
    var signal = state.controller.signal;
    var baseHref = moduleRoot.ownerDocument.baseURI;
    var emptySelections = {measurement: [], range: [], frequency: null};
    var catalogUrl = createFilterUrl(config.collection_url, emptySelections, config.section_id, baseHref);

    setBusy(moduleRoot, true);
    setStatus(moduleRoot, config.labels.loading);

    var catalogPromise = state.catalog
      ? Promise.resolve(state.catalog)
      : requestResponse(moduleRoot, catalogUrl.href, signal).then(function (responseRoot) {
        ensureCurrent(state, sequence);
        state.catalog = parseCatalog(responseRoot);
        return state.catalog;
      });

    return catalogPromise.then(function (catalog) {
      ensureCurrent(state, sequence);

      var measurementValues = findMeasurementValues(catalog, definition);
      var rangeSelection = selectMeasurementRange(catalog, definition, measuredValue);
      if (measurementValues.length === 0 || !rangeSelection) {
        showFallbackProducts(
          moduleRoot,
          config,
          config.labels.no_range,
        );
        return null;
      }

      var primaryBaseSelections = {
        measurement: measurementValues,
        range: rangeSelection.values,
        frequency: null,
      };
      var primaryBaseRequestUrl = createFilterUrl(
        config.collection_url,
        primaryBaseSelections,
        config.section_id,
        baseHref,
      );
      var primaryBasePromise = requestFilterCatalog(
        moduleRoot,
        primaryBaseRequestUrl.href,
        signal,
        state,
      );
      var includeNextRange = shouldIncludeNextRange(rangeSelection, measuredValue);
      var nextBaseSelections = rangeSelection.nextValues.length > 0 ? {
        measurement: measurementValues,
        range: rangeSelection.nextValues,
        frequency: null,
      } : null;
      var nextBaseRequestUrl = nextBaseSelections ? createFilterUrl(
        config.collection_url,
        nextBaseSelections,
        config.section_id,
        baseHref,
      ) : null;

      function requestNextBaseCatalog() {
        if (!nextBaseRequestUrl) return Promise.resolve(null);
        return requestOptionalFilterCatalog(
          moduleRoot,
          nextBaseRequestUrl.href,
          signal,
          state,
        );
      }

      return primaryBasePromise.then(function (primaryBaseCatalog) {
        ensureCurrent(state, sequence);
        var primaryFrequencyValues = selectFrequencyValues(
          primaryBaseCatalog,
          definition.metric,
          frequencyHz,
        );

        if (includeNextRange || (primaryFrequencyValues.length === 0 && nextBaseSelections)) {
          return Promise.all([Promise.resolve(primaryBaseCatalog), requestNextBaseCatalog()]);
        }
        return [primaryBaseCatalog, null];
      }).then(function (baseCatalogs) {
        ensureCurrent(state, sequence);

        var primaryFrequencyValues = selectFrequencyValues(
          baseCatalogs[0],
          definition.metric,
          frequencyHz,
        );
        var nextFrequencyValues = baseCatalogs[1]
          ? selectFrequencyValues(baseCatalogs[1], definition.metric, frequencyHz)
          : [];
        if (primaryFrequencyValues.length === 0 && nextFrequencyValues.length === 0) {
          showFallbackProducts(
            moduleRoot,
            config,
            config.labels.no_frequency,
          );
          return null;
        }

        var useNextRange = nextFrequencyValues.length > 0;
        var nextSelections = useNextRange ? {
          measurement: measurementValues,
          range: rangeSelection.nextValues,
          frequency: nextFrequencyValues,
        } : null;

        function presentFinal(finalResponseRoot, nextResponseRoot, plpSelections, statusRange, statusFrequency, totalOverride) {
          ensureCurrent(state, sequence);
          var total = Number.isFinite(Number(totalOverride))
            ? Number(totalOverride)
            : responseTotal(finalResponseRoot);
          if (total === 0) {
            var zeroFallbackCount = showFallbackProducts(moduleRoot, config, '');
            if (zeroFallbackCount === 0) setStatus(moduleRoot, config.labels.no_products);
            return null;
          }

          function renderFinal(diversityResponseRoot) {
            ensureCurrent(state, sequence);
            var rendered = renderCards(
              moduleRoot,
              finalResponseRoot,
              nextResponseRoot,
              diversityResponseRoot,
            );
            setBusy(moduleRoot, false);
            var finalPlpUrl = createFilterUrl(config.collection_url, plpSelections, null, baseHref);
            var matchedStatus = replaceTemplate(config.labels.matched_template, {
              metric: config.metric_labels[definition.metric] || definition.metric,
              range: statusRange,
              frequency: statusFrequency,
              count: total,
            });
            setStatus(moduleRoot, fallbackStatus(
              matchedStatus,
              config.labels.fallback_partial,
              rendered.fallbackCount,
            ));
            setButton(moduleRoot, relativeUrl(finalPlpUrl), config.labels.matched_button);
            return true;
          }

          var currentEntries = responseCardEntries(finalResponseRoot, 'combined');
          var diversityCatalog = parseCatalog(finalResponseRoot);
          if (nextResponseRoot) {
            currentEntries = currentEntries.concat(responseCardEntries(nextResponseRoot, 'next'));
            diversityCatalog = diversityCatalog.concat(parseCatalog(nextResponseRoot));
          }
          var currentFamilies = unique(currentEntries.map(function (entry) {
            return entry.family;
          }).filter(Boolean));
          var diversitySeriesValues = selectDiversitySeriesValues(
            diversityCatalog,
            currentFamilies,
            Math.max(0, 3 - currentFamilies.length),
          );
          if (diversitySeriesValues.length === 0) return renderFinal(null);

          var diversitySelections = {
            measurement: plpSelections.measurement,
            range: plpSelections.range,
            frequency: plpSelections.frequency,
            series: diversitySeriesValues,
          };
          var diversityRequestUrl = createFilterUrl(
            config.collection_url,
            diversitySelections,
            config.section_id,
            baseHref,
          );
          return requestOptionalResponse(moduleRoot, diversityRequestUrl.href, signal).then(function (diversityResponseRoot) {
            return renderFinal(diversityResponseRoot);
          });
        }

        if (primaryFrequencyValues.length === 0) {
          var nextOnlyRequestUrl = createFilterUrl(
            config.collection_url,
            nextSelections,
            config.section_id,
            baseHref,
          );
          return requestResponse(moduleRoot, nextOnlyRequestUrl.href, signal).then(function (nextOnlyResponseRoot) {
            return presentFinal(
              nextOnlyResponseRoot,
              null,
              nextSelections,
              rangeSelection.nextLabel,
              nextFrequencyValues.join(' / '),
            );
          });
        }

        var primarySelections = {
          measurement: measurementValues,
          range: rangeSelection.values,
          frequency: primaryFrequencyValues,
        };
        var primaryRequestUrl = createFilterUrl(
          config.collection_url,
          primarySelections,
          config.section_id,
          baseHref,
        );
        var primaryFinalPromise = requestResponse(moduleRoot, primaryRequestUrl.href, signal);

        if (!useNextRange) {
          return primaryFinalPromise.then(function (primaryResponseRoot) {
            return presentFinal(
              primaryResponseRoot,
              null,
              primarySelections,
              rangeSelection.label,
              primaryFrequencyValues.join(' / '),
            );
          });
        }

        var nextRequestUrl = createFilterUrl(
          config.collection_url,
          nextSelections,
          config.section_id,
          baseHref,
        );
        var nextFinalPromise = requestOptionalResponse(moduleRoot, nextRequestUrl.href, signal);

        return Promise.all([
          primaryFinalPromise,
          nextFinalPromise,
        ]).then(function (finalResponseRoots) {
          ensureCurrent(state, sequence);

          var primaryResponseRoot = finalResponseRoots[0];
          var nextResponseRoot = finalResponseRoots[1];
          var nextTotal = nextResponseRoot ? responseTotal(nextResponseRoot) : 0;
          if (nextTotal === 0) {
            return presentFinal(
              primaryResponseRoot,
              null,
              primarySelections,
              rangeSelection.label,
              primaryFrequencyValues.join(' / '),
            );
          }

          var combinedFrequencyValues = unique(primaryFrequencyValues.concat(nextFrequencyValues));
          var combinedSelections = {
            measurement: measurementValues,
            range: rangeSelection.values.concat(rangeSelection.nextValues),
            frequency: combinedFrequencyValues,
          };
          return presentFinal(
            primaryResponseRoot,
            nextResponseRoot,
            combinedSelections,
            [rangeSelection.label, rangeSelection.nextLabel].join(' / '),
            combinedFrequencyValues.join(' / '),
            combinedResponseTotal(primaryResponseRoot, nextResponseRoot),
          );
        });
      });
    }).catch(function (error) {
      if (error && error.name === 'AbortError') return false;
      if (sequence !== state.requestSequence) return false;
      showFallbackProducts(moduleRoot, config, config.labels.error);
      return false;
    });
  }

  function initRoot(calculatorRoot) {
    if (!calculatorRoot || calculatorRoot.__hauberVibrationProductMatchesInitialized) return false;
    var moduleRoot = calculatorRoot.querySelector(PRODUCT_SELECTOR);
    if (!moduleRoot) return false;

    var config;
    try {
      config = readConfig(moduleRoot);
    } catch (error) {
      moduleRoot.hidden = true;
      return false;
    }

    calculatorRoot.__hauberVibrationProductMatchesInitialized = true;
    var calculatorState = calculatorRoot.__hauberVibrationCalculatorState;
    var state = {
      targetKey: calculatorRoot.getAttribute('data-vibration-target-key') || null,
      result: calculatorState && calculatorState.result ? calculatorState.result : null,
      requestSequence: 0,
      controller: null,
      catalog: null,
      frequencyCatalogs: Object.create(null),
      updateTimer: null,
    };

    showFallbackProducts(
      moduleRoot,
      config,
      state.targetKey ? config.labels.waiting : config.labels.initial,
    );

    calculatorRoot.addEventListener('hauber:vibration-target-change', function (event) {
      state.targetKey = event.detail && event.detail.key ? event.detail.key : null;
      if (event.detail && Object.prototype.hasOwnProperty.call(event.detail, 'result')) {
        state.result = event.detail.result;
      }
      scheduleMatchesUpdate(calculatorRoot, moduleRoot, config, state);
    });

    calculatorRoot.addEventListener('hauber:vibration-result-change', function (event) {
      state.result = event.detail ? event.detail.result : null;
      scheduleMatchesUpdate(calculatorRoot, moduleRoot, config, state);
    });

    return true;
  }

  function init(scope) {
    if (!scope) return 0;
    var roots = [];
    if (scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
    if (scope.querySelectorAll) {
      var descendants = scope.querySelectorAll(ROOT_SELECTOR);
      for (var index = 0; index < descendants.length; index += 1) roots.push(descendants[index]);
    }

    var initialized = 0;
    for (var rootIndex = 0; rootIndex < roots.length; rootIndex += 1) {
      if (initRoot(roots[rootIndex])) initialized += 1;
    }
    return initialized;
  }

  function boot(documentReference) {
    if (!documentReference) return;

    if (documentReference.readyState === 'loading') {
      if (!documentReference.__hauberVibrationProductMatchesReadyListener) {
        documentReference.__hauberVibrationProductMatchesReadyListener = true;
        documentReference.addEventListener('DOMContentLoaded', function () {
          init(documentReference);
        });
      }
    } else {
      init(documentReference);
    }

    if (!documentReference.__hauberVibrationProductMatchesSectionListener) {
      documentReference.__hauberVibrationProductMatchesSectionListener = true;
      documentReference.addEventListener('shopify:section:load', function (event) {
        init(event.target);
      });
    }
  }

  return Object.freeze({
    FILTER_PARAMS: FILTER_PARAMS,
    TARGET_DEFINITIONS: TARGET_DEFINITIONS,
    UPDATE_DEBOUNCE_MS: UPDATE_DEBOUNCE_MS,
    boot: boot,
    createFilterUrl: createFilterUrl,
    findMeasurementValues: findMeasurementValues,
    frequencyOptionIsCompatible: frequencyOptionIsCompatible,
    getTargetDefinition: getTargetDefinition,
    init: init,
    normalizeFilterText: normalizeFilterText,
    normalizeSeriesCodes: normalizeSeriesCodes,
    optionsFor: optionsFor,
    parseFrequencyIntervals: parseFrequencyIntervals,
    parseRange: parseRange,
    relativeUrl: relativeUrl,
    replaceTemplate: replaceTemplate,
    selectDiversitySeriesValues: selectDiversitySeriesValues,
    selectFrequencyValues: selectFrequencyValues,
    selectFallbackProducts: selectFallbackProducts,
    selectMeasurementRange: selectMeasurementRange,
    selectProductEntries: selectProductEntries,
    scheduleMatchesUpdate: scheduleMatchesUpdate,
    shouldIncludeNextRange: shouldIncludeNextRange,
    targetUnsupportedReason: targetUnsupportedReason,
    updateMatches: updateMatches,
  });
});
